// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"i_-z"};